"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "porpetto": {
    "ea78b445": [{
      "hkey": "63451918",
      "slug": "porpetto",
      "name": "Porpetto",
      "primary": true,
      "skipSearch": false
    }],
    "fornaci-forredana": [{
      "hkey": "63451918",
      "slug": "porpetto",
      "name": "Porpetto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "b405272c": [{
      "hkey": "63451918",
      "slug": "porpetto",
      "name": "Porpetto",
      "primary": true,
      "skipSearch": false
    }],
    "villalta": [{
      "hkey": "63451918",
      "slug": "porpetto",
      "name": "Porpetto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;